import * as yup from "yup";

const bookingFlow = {
  date: yup.string().required("Please select a date"),
  time: yup.mixed().notOneOf(["unspecified"], "Please select a time"),
};

export const bookingFlowSchema = yup.object().shape(bookingFlow);
